<div [formGroup]="transferForm" class="row modal-body p-3 text-dark fw-bold">
    <h5>Póliza a Contratar</h5>
    <div class="mt-2 col-xxl-4 col-md-6 col-sm-4">
        <label for="relationshipId" class="fw-bold">Tipo Asegurado</label>
        <ng-select [items]="listInsuredTypes" bindLabel="name" bindValue="_id" formControlName="relationshipId" id="relationshipId"
            placeholder="Tipo asegurado" (change)="changeTypeInsured($event)" appendTo="body"> </ng-select>
    </div>
    @if(findHolderData == true){
    <div class="mt-2 col-xxl-4 col-md-6 col-sm-4" formGroupName="holder">
        <label for="holder-rut" class="fw-bold">Rut Titular</label>
        <input type="text" class="form-control" formControlName="rut" id="holder-rut" placeholder="Rut Titular"
            (blur)="getHolderInformation()">
        @if(transferForm.get('holder').get('rut').touched && transferForm.get('holder').get('rut').invalid){
        <small class="text-danger">Dato Obligatorio</small>
        }
    </div>
    @if(transferForm.get('holder.names')?.value){
    <div class="mt-2 col-xxl-4 col-md-6 col-sm-4" formGroupName="holder">
        <label class="fw-bold">Nombre Completo</label>
        <span class="form-control">{{ transferForm.get('holder.names')?.value }} {{
            transferForm.get('holder.surname')?.value }} {{ transferForm.get('holder.lastname')?.value }}</span>
    </div>
    <div class="mt-2 col-xxl-4 col-md-6 col-sm-4" formGroupName="holder">
        <label class="fw-bold">Cargo</label>
        <span class="form-control">{{ transferForm.get('holder.position')?.value }}</span>
    </div>
    }
    }

    <div class="mt-2 col-xxl-4 col-xl-6 col-sm-12">
        <label for="entityId" class="fw-bold">Campo</label>
        <ng-select [items]="listEntities" bindLabel="name" bindValue="_id" formControlName="entityId" id="entityId"
            placeholder="Campo Destino" (change)="getPoliciesDestiny()" appendTo="body"> </ng-select>
    </div>
    <div class="mt-2 col-xxl-4 col-md-6 col-sm-6">
        <label for="policyId" class="fw-bold">Póliza</label>
        <ng-select [items]="listPolicies" bindLabel="code" bindValue="_id" formControlName="policyId" id="policyId"
            placeholder="Póliza Destino" (change)="getGroupOfPolicy($event)" appendTo="body"> </ng-select>
    </div>
    <div class="mt-2 col-xxl-4 col-md-6 col-sm-6">
        <label for="groupId" class="fw-bold">Grupo</label>
        <ng-select [items]="listGroups" bindLabel="name" bindValue="_id" formControlName="groupId" id="groupId"
            placeholder="Grupo Destino" (change)="getPositions()" appendTo="body"> </ng-select>
    </div>
    <div class="mt-2 col-xxl-4 col-md-6 col-sm-6">
        <label for="jobTitleId" class="fw-bold">Cargo</label>
        <ng-select [items]="listPositions" bindLabel="name" bindValue="_id" formControlName="jobTitleId" id="jobTitleId"
            placeholder="Cargo" (change)="setCapital()" appendTo="body"> </ng-select>
    </div>
    <div class="mt-2 col-xxl-4 col-md-6 col-sm-4">
        <label for="capital" class="fw-bold">Capital</label>
        <input type="text" class="form-control" formControlName="capital" id="capital" placeholder="Capital base">
        @if(transferForm.get('capital').touched && transferForm.get('capital').invalid){
        <small class="text-danger">Dato Obligatorio</small>
        }

    </div>
    <div class="mt-2 col-xxl-4 col-md-6 col-sm-4">
        <label for="dateStart" class="fw-bold">Fecha Vigencia</label>
        <input type="date" class="form-control" formControlName="dateStart" id="dateStart" [min]="minDate" [max]="maxDate">
        @if(transferForm.get('dateStart').touched && transferForm.get('dateStart').invalid){
        <small class="text-danger">Dato Obligatorio</small>
        }
    </div>

</div>
@if(showMissionaryForm){
<div [formGroup]="transferForm" class="row modal-body p-3 mt-3 text-dark fw-bold">
     <h5>Datos Eclesiásticos</h5>
      <div class="mt-2 col-xxl-4 col-md-4">
        <label for="voteType" class="fw-bold">Tipo de Junta</label>
        <ng-select [items]="typeBoard" formControlName="voteType" id="voteType" placeholder="Tipo Junta"> </ng-select>
         @if(transferForm.get('voteType').touched && transferForm.get('voteType').invalid){
        <small class="text-danger">Dato Obligatorio</small>
        }
    </div>
     <div class="mt-2 col-xxl-4 col-md-4">
        <label for="voteNumber" class="fw-bold">Número de Voto</label>
       <input type="text" class="form-control" formControlName="voteNumber" id="voteNumber" placeholder="Número del Voto">
        @if(transferForm.get('voteNumber').touched && transferForm.get('voteNumber').invalid){
        <small class="text-danger">Dato Obligatorio</small>
        }
    </div>
     <div class="mt-2 col-xxl-4 col-md-4">
        <label for="voteDate" class="fw-bold">Fecha</label>
        <input type="date" class="form-control" formControlName="voteDate" id="voteDate" placeholder="Fecha del Voto">
          @if(transferForm.get('voteDate').touched && transferForm.get('voteDate').invalid){
        <small class="text-danger">Dato Obligatorio</small>
        }
    </div>
     <div class="mt-2 col-xxl-4 col-md-12">
        <label for="voteDetail" class="fw-bold">Descripción del Voto</label>
        <textarea rows="5" class="form-control" formControlName="voteDetail" id="voteDetail" placeholder="Descripción del voto"></textarea>
          @if(transferForm.get('voteDetail').touched && transferForm.get('voteDetail').invalid){
        <small class="text-danger">Dato Obligatorio</small>
        }
    </div>
</div>
}


<div class="modal-footer d-flex justify-content-end gap-2 flex-wrap p-3">
    @if(!hideNavigation){
    <button class="btn btn-outline-secondary btn-xs" (click)="back.emit()"><i class="fas fa-arrow-left"></i> Volver</button>
    <button class="btn btn-outline-danger btn-xs" (click)="cancel.emit()"><i class="fas fa-times"></i> Cancelar</button>
    }
    <button class="btn btn-primary btn-xs" (click)="save()"><i class="fas fa-save"></i> Finalizar</button>
</div>